import api from './api';

const paymentService = {
	createOrder: async (packageType) => {
		const response = await api.post('/payments/create-order', { packageType });
		return response.data;
	},
	verifyPayment: async (paymentData) => {
		const response = await api.post('/payments/verify-payment', paymentData);
		return response.data;
	},
	getPaymentHistory: async (page = 1, limit = 10) => {
		const response = await api.get(`/payments/history?page=${page}&limit=${limit}`);
		return response.data;
	}
};

export default paymentService;


